import { Component, OnInit, Input, NgModule, ViewChild, TemplateRef, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InfoB } from '@app/models/infobox';
import { CommonModule } from '@angular/common';
import { CssBackgroundImageProxyModule } from '@app/directives/css-background-image-proxy.directive';
import { MatDialog } from '@angular/material/dialog';
import { SafeModule } from '@app/pipes/safe.pipe';
import { LinkModule } from '@app/directives/link.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoComponent implements OnInit {
  _box: InfoB;

  @Input() set box(value) {
    this._box = value;
    this.cdr.markForCheck();
  }
  @Input() styleClasses: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() customStyle: { [klass: string]: any; };
  @Input() isAreaHero: boolean;
  @ViewChild('videoTmpl', { static: true }) videoTmpl: TemplateRef<any>;

  constructor(private dialog: MatDialog, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  openVideoDialog(event: any) {
    event.preventDefault();
    this.dialog.open(this.videoTmpl, {
      id: 'videoTmpl',
      hasBackdrop: true,
      closeOnNavigation: true,
      panelClass: 'infobox-videoplayingcontainer',
      autoFocus: true,
    });
  }
  closeVideo() {
    this.dialog.getDialogById('videoTmpl').close();
  }

  getBannerBackGround() {
    const bannerBackGround = {
       'background-color': this._box.TextBackgroundBanner,
       'width': '100%' ,
       'padding-top': '20px' ,
       'padding-bottom': '20px'
     };

    return bannerBackGround;
   }
}
@NgModule({
  declarations: [VideoComponent],
  exports: [VideoComponent],
  imports: [
    CommonModule,
    CssBackgroundImageProxyModule,
    SafeModule,
    LinkModule,
    MatIconModule,
    MatButtonModule,
  ]
})
export class VideoInfoboxModule { }
